<template>
    <input />
</template>

<style>
/* Overriding styles from vue-strap */
.datepicker-dropdown {
    position: absolute !important;
}
</style>

<script>
    export default {
        props: ['options', 'value'],
        mounted() {
            var vm = this;
            jQuery(this.$el)
                .val(this.value)
                .datepicker(this.options)
                .on('change', function() {
                    vm.$emit('input', this.value);
                });
        },
        watch: {
            value: function(value) {
                jQuery(this.$el).val(value);
            },
        },
        destroyed() {
            jQuery(this.$el).off();
        },
    }
</script>
